import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcAcceptDatabase, FcPhone, FcStackOfPhotos } from "react-icons/fc";
import SimpleButton from "../../Components/layouts/simple_button";

const ViewBookingDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  let { id } = useParams();

  // ==========================================
  // GET CALL DETAILS
  // ==========================================

  useEffect(() => {
    setLoading(true);

    performRequest("GET", `/get-call/getaibookingById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.aiBookingData);
        } else {
          Toast("error", "Error while fetching booking details");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          {/* HEADER */}

          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcAcceptDatabase className="fs-2 me-1" />
                  View Ai Booking Enrollments
                </h2>

                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>

          {/* MAIN CARD */}

          <div className="card my-4">
            {/* CARD HEADER */}

            <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h2 className="page-title">
                  View Ai Booking Enrollments Details
                </h2>
              </div>
            </div>

            {/* CARD BODY */}

            <div className="card-body">
              {/* CUSTOMER NAME */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Customer Name :</label>

                <div className="w-100 col">{data?.customerName || "N/A"}</div>
              </div>

              {/* PHONE NUMBER */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Customer Number :
                </label>

                <div className="w-100 col">{data?.contactNumber || "N/A"}</div>
              </div>

              {/* CITY */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">City :</label>

                <div className="w-100 col">{data?.city || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3"> Booking Type :</label>

                <div className="w-100 col">{data?.bookingType || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3"> Booking Date:</label>

                <div className="w-100 col">{data?.bookingDate || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Amount:</label>

                <div className="w-100 col">{data?.paymentAmount || "N/A"}</div>
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewBookingDetails;
